import React from 'react';
import ProductHome from './ProductHome/index';

const MarketLay: React.FC = (Props: any) => (
  <>
    <ProductHome />
  </>
);

export default MarketLay;
